// OneDrive:IgnoreCodeCoverage

export { PlatformDetection as default } from '@ms/utilities-browser/lib/PlatformDetection';